import * as yup from 'yup';
export const validUser = (userId, { createError }) => {
	if (userId) {
		const upperCaseUserId = userId.toUpperCase();
		if (/^([A-Z]{1}\d{4})$/.test(upperCaseUserId)) {
			return true;
		} else {
			return createError({
				message: 'This is not a valid UserID.'
			});
		}
	}
};
const schema = yup.object().shape({
	userID: yup.string().required().test(validUser),
	lastFour: yup.string().required('The last 4 numbers of your SSN are required.').test('len', 'Must be exactly 4 numbers of your SSN.', val => val?.length === 4).matches(/^[0-9]+$/, 'Must be only numbers.'),
	vaccinationStatus: yup.string().required('You are required to select a status.')
});

export default schema;